"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import _ from "underscore";
import Account from "../api/account";
import classNames from "classnames";
import { Link } from "react-router";
import { isIndexerMode } from "./index_audit_split_mode";
function showStep(props, step) {
  var classes = classNames({
    "indexer-progress__item": true,
    "indexer-progress__item__url": step.url,
    "indexer-progress__item--clickable": step.url || stepClickable(props, step),
    "indexer-progress__item__active": props.stepNumber === step.number,
    "indexer-progress__item__completed": props.stepNumber > step.number
  });
  var click = () => onStepClicked(props, step);
  return /* @__PURE__ */ jsx("li", { className: classes, onClick: click, children: stepElement(props, step) }, step.number);
}
function stepElement(props, step) {
  if (showLink(props, step)) {
    return /* @__PURE__ */ jsx(Link, { to: step.url, children: stepContent(props, step) });
  } else {
    return stepContent(props, step);
  }
}
function stepContent(props, step) {
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx("div", { className: "indexer-progress__indicator", children: /* @__PURE__ */ jsx("div", { className: "indexer-progress__indicator-inner", children: "\xA0" }) }),
    /* @__PURE__ */ jsxs("span", { children: [
      " ",
      step.label
    ] }),
    possibleTrailer(props, step)
  ] });
}
function showLink(props, step) {
  return step.url && props.stepNumber !== step.number;
}
function possibleTrailer(props, step) {
  const lastStep = _.last(props.steps);
  if (lastStep && step.number !== lastStep.number) {
    return /* @__PURE__ */ jsx("hr", { className: "indexer-progress__trailer" });
  }
}
function stepClickable(props, step) {
  return props.onStepClicked && step.number <= props.stepNumber;
}
function onStepClicked(props, step) {
  if (props.onStepClicked && stepClickable(props, step)) {
    props.onStepClicked(step);
  }
}
function ProgressBar(props) {
  return /* @__PURE__ */ jsx("div", { "data-component": "ProgressBar", className: "document-indexer__progress", children: /* @__PURE__ */ jsxs("div", { className: "indexer-progress__container", children: [
    props.sidebarTrigger,
    /* @__PURE__ */ jsx("ul", { className: "indexer-progress__list", children: _.map(props.steps, (step) => showStep(props, step)) })
  ] }) });
}
function batchUrl(props) {
  if (props.batchId && props.stepNumber === 4) {
    let onDone = "/dashboard";
    if (props.location && props.location.query.onDone) {
      onDone = props.location.query.onDone;
    }
    return "/index-document-batches/" + props.batchId + "?onDone=" + encodeURIComponent(onDone);
  } else {
    return null;
  }
}
function inIndexerMode(props) {
  return isIndexerMode(props.location);
}
function steps(props) {
  var allSteps = [
    { number: 0, label: stepLabel(props, 0) },
    { number: 1, label: stepLabel(props, 1) },
    { number: 2, label: stepLabel(props, 2) },
    {
      number: 3,
      label: stepLabel(props, 3),
      url: batchUrl(props)
    },
    { number: 4, label: stepLabel(props, 4) }
  ];
  return allSteps.filter((step) => Boolean(step.label));
}
function stepIndex3Label(props) {
  if (Account.hasRole("Factor")) {
    if (inIndexerMode(props)) {
      return "Assign Debtor";
    } else {
      return "Create and Submit Invoice";
    }
  } else {
    if (props.multiCarrier) {
      return `Assign Loads & ${Account.carrierTerm()}s`;
    } else {
      return "Assign Loads";
    }
  }
}
function stepIndex4Label(props) {
  if (Account.hasRole("Factor")) {
    if (inIndexerMode(props)) {
      return "Review";
    } else {
      return null;
    }
  } else {
    if (inIndexerMode(props)) {
      return null;
    } else {
      return "Confirm & Submit";
    }
  }
}
function stepLabel(props, stepIndex) {
  return [
    function() {
      return `Assign ${Account.carrierTerm()}`;
    },
    function() {
      return "Identify Documents";
    },
    function() {
      return "Group Documents";
    },
    () => {
      return stepIndex3Label(props);
    },
    () => {
      return stepIndex4Label(props);
    }
  ][stepIndex]();
}
function IndexerProgress(props) {
  return /* @__PURE__ */ jsx(
    ProgressBar,
    {
      steps: steps(props),
      onStepClicked: props.onStepClicked,
      stepNumber: props.stepNumber,
      sidebarTrigger: props.sidebarTrigger
    }
  );
}
const REPLY_STEPS = [
  { number: 1, label: "View Reply" },
  { number: 2, label: "Identify Documents" },
  { number: 3, label: "Validate & Accept" }
];
function ReplyProgressBar(props) {
  return /* @__PURE__ */ jsx(ProgressBar, { steps: REPLY_STEPS, stepNumber: props.stepNumber });
}
const NO_DOCUMENTS_STEPS = [
  { number: 0, label: `Assign ${Account.carrierTerm()}` },
  { number: 1, label: "Respond or Complete" }
];
function NoDocumentsProgressBar(props) {
  return /* @__PURE__ */ jsx(
    ProgressBar,
    {
      steps: NO_DOCUMENTS_STEPS,
      stepNumber: props.stepNumber,
      sidebarTrigger: props.sidebarTrigger
    }
  );
}
export { IndexerProgress, ReplyProgressBar, NoDocumentsProgressBar };
